module.exports = __webpack_public_path__ + "static/img/no_hotel.712956d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/no_hotel.png
// module id = PSuT
// module chunks = 0